import { Heading } from 'client/shared/blocks/heading/heading'
import Spacer from 'client/shared/blocks/spacer/spacer'
import React, { Component } from 'react'

import './showcase.styl'

export default class Showcase extends Component<{
  heading: JSX.Element | null
}> {
  render(): JSX.Element {
    const { children, heading } = this.props

    return (
      <div className="showcase">
        {heading && (
          <>
            <Spacer size={32} />
            <Heading rank={1}>{heading}</Heading>
          </>
        )}
        {children}
      </div>
    )
  }
}
